import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/materiais")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="materials"
      label="Materiais para download"
      imageFolder="materiais"
      fields={[
        { name: "title", label: "Título", type: "text", required: true },
        { name: "description", label: "Descrição", type: "textarea" },
        {
          name: "kind",
          label: "Tipo",
          type: "select",
          options: [
            { label: "Documento (PDF)", value: "documento" },
            { label: "Imagem", value: "imagem" },
            { label: "Vídeo", value: "video" },
            { label: "Áudio", value: "audio" },
            { label: "Outro", value: "outro" },
          ],
        },
        { name: "file_url", label: "Arquivo", type: "file", required: true, fullWidth: true },
        { name: "cover_url", label: "Capa (opcional)", type: "image", fullWidth: true },
        { name: "file_size", label: "Tamanho (ex.: 2 MB)", type: "text" },
        { name: "featured", label: "Destaque", type: "boolean" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Título" },
        { key: "kind", label: "Tipo" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
